<template>
    <div :class="barClass">
      <div ref="slider" class="progress-bar__slider" @mousemove="calcPos" @mouseenter="calcPos" @mouseleave="hideProgressFrame" @click="onSliderClick">
        <!-- 播放进度 -->
        <div class="progress__played" ref="played" :style="{width:currentPercentage+'%'}"></div>
        <!-- 滑动按钮 -->
        <slide-button v-if="!sliderDisabled" ref="sliderButton" v-model="currentPercentage" />
        <!-- 缓冲条 -->
        <div class="progress__buffer" ref="buffer" :style="{width:buffered}"></div>
        <!-- 帧 -->
        <div ref="frame" class="progress__frame"></div>
        <!-- tooltip -->
        <div ref="frameTip" class="frame__tip">{{pointerPercentage|filterPercentage(this)}}</div>
      </div>
    </div>
  </template>
  
  <script>
  import SlideButton from './SlideButton.vue'
  export default {
    name: 'ProgressBar',
    components: { SlideButton },
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: { type: Number, default: 0 },
      disabled: { type: Boolean, default: false }, // 进度条是否可拖拽
      duration: { type: [Number, String], default: 0 }, // 视频总时长
      buffered: { type: [Number, String], default: 0 }, // 缓冲进度
      showTooltip: { type: Boolean, default: false }, // 写了另外的tooltip，这个可根据需要直接删，这是控制SlideButton中el-tooltip显示的，没有配合自己写的tooltip功能
    },
    filters: {
      filterPercentage(val, that) {
        return that.formatTooltip(val)
      }
    },
    computed: {
      sliderDisabled() {
        return this.disabled
      },
      barClass() {
        let classStr = ''
        if (this.dragging) {
          classStr += ' is-dragging'
        }
        if (this.sliderDisabled) {
          classStr += ' is-disabled'
        }
        return 'progress-bar' + classStr
      }
    },
    data() {
      return {
        currentPercentage: 0,
        wrapperPos: 0,
        pointerPercentage: 0, // 鼠标指向时间
        played: 0, // 播放进度
        sliderSize: 1, // 进度条尺寸
        vertical: false, // 这个是因为 el-slider 支持竖向，但是这里没有写竖向功能，先预留，等后续开发~
        step: 1,
        dragging: false
      }
    },
    watch: {
      value() {
        if (this.dragging) {
          return
        }
        this.getPercentage()
      }
    },
    created() {
      this.getPercentage()
    },
    mounted() {
      const bounds = this.$refs.slider.getBoundingClientRect()
      this.wrapperPos = bounds.left
      this.resetSize()
    },
    methods: {
      resetSize() {
        if (this.$refs.slider) {
          this.sliderSize = this.$refs.slider[`clientWidth`];
        }
      },
      // 计算当前鼠标指向位置
      calcPos(e) {
        if (this.disabled) return
        if (this.$refs.sliderButton.hovering || this.dragging) {
            if (this.$refs.sliderButton.hovering) {
            this.pointerPercentage = this.currentPercentage
          }
          this.$refs.frame.style.display = 'none'
          return
        }
        this.setFramePosition(e)
        this.setTooltipPosition(e)
      },
      calcPosition(e) {
        const offsetX = e.clientX - this.wrapperPos
        const pos = offsetX < 0 ? 0 : offsetX > this.sliderSize ? this.sliderSize : offsetX
        // 当前鼠标指针进度百分比
        this.pointerPercentage = parseFloat(pos / this.sliderSize * 100)
        return pos
      },
      // 指示器位置（鼠标移动时的小白条）
      setFramePosition(e) {
        const pos = this.calcPosition(e)
        this.$refs.frame.style.left = pos / this.sliderSize * 100 + '%'
        this.$refs.frame.style.display = 'block'
      },
      // tooltip（指示时间）
      setTooltipPosition(e) {
        const pos = this.calcPosition(e)
        // 计算 tooltip 位置，获取 tooltip 宽度
        const tipWidth = this.$refs.frameTip?.getBoundingClientRect().width
        // 贴边偏移量，到边缘左右位置不再变化
        const tipOffset = tipWidth / 2
        const tipPos = pos < tipOffset ? tipOffset : pos > this.sliderSize - tipOffset ? this.sliderSize - tipOffset : pos
        this.$refs.frameTip.style.left = tipPos / this.sliderSize * 100 + '%'
        this.$refs.frameTip.style.display = 'block'
      },
      hideProgressFrame() {
        // 隐藏指示器
        setTimeout(() => {
          this.$refs.frame.style.display = 'none'
          this.$refs.frameTip.style.display = 'none'
        }, 200)
      },
      onSliderClick() {
        if (this.sliderDisabled || this.dragging) return;
        this.setPosition()
        this.emitChange()
      },
      setPosition() {
        this.$refs.sliderButton.setPosition(this.pointerPercentage)
      },
      getPercentage() {
        this.currentPercentage = !isNaN(this.duration) && this.duration > 0 ? this.value / this.duration * 100 : 0
      },
      formatTooltip(val) {
        const time = this.duration * (val / 100)
        return this.formatTime(time)
      },
      formatTime(t) {
        let time = '0:00'
        if (t) {
          const h = parseInt(t / 3600)
          const m = parseInt(t % 3600 / 60)
          let s = parseInt(t % 60)
          s = s < 10 ? '0' + s : s
          time = h ? h + ':' + m + ':' + s : m + ':' + s
        }
        return time
      },
      emitChange() {
        const currentTime = this.duration * this.currentPercentage / 100
        this.$emit('change', currentTime)
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .progress-bar {
    position: absolute;
    height: 2px;
    top: -2px;
    z-index: 2;
    left: 0;
    width: 100%;
    margin: 0 8px;
    width: calc(100% - 16px);
    transition: all 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
    background-color: rgba(255, 255, 255, 0.3);
    cursor: pointer;
    .progress__played,
    .progress__buffer {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
    }
    .progress__buffer {
      background-color: rgba(169, 169, 169, 0.7);
      z-index: 1;
    }
    .progress__played {
      z-index: 2;
      background: #1479f9;
    }
  }
  .played__slider {
    position: absolute;
    height: 14px;
    width: 14px;
    background: #fff;
    border-radius: 50%;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  .progress-bar__slider {
    position: relative;
    height: 100%;
    width: 100%;
  }
  .progress__frame {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 3px;
    left: 0;
    background: #fff;
    z-index: 99;
    display: none;
    cursor: pointer;
  }
  .frame__tip {
    position: absolute;
    top: -38px;
    left: 0;
    transform: translateX(-50%);
    width: fit-content;
    height: fit-content;
    background: rgba(0, 0, 0, 0.6);
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
    user-select: none;
    display: none;
  }
  .progress-bar.is-dragging,
  .progress-bar:not(.is-disabled):hover {
    height: 10px;
    top: -10px;
  }
  .progress-bar:hover ::v-deep .el-slider__button {
    background-color: #fff;
  }
  .progress-bar.is-disabled {
    &,
    .progress__frame,
    .played__slider {
      cursor: default;
    }
  }
  </style>
  